export const AUTHORIZATION_ERROR_FORBIDDEN = 'AUTHORIZATION_ERROR_FORBIDDEN';
export const AUTHORIZATION_ERROR_INVALID_USERNAME_OR_PASSWORD = 'AUTHORIZATION_ERROR_INVALID_USERNAME_OR_PASSWORD';
export const AUTHORIZATION_ERROR_NOT_AUTHORIZED = 'AUTHORIZATION_ERROR_NOT_AUTHORIZED';
export const AUTHORIZATION_ERROR_LOCKED_OUT = 'AUTHORIZATION_ERROR_LOCKED_OUT';
export const CONFIGURATION_ERROR_NOT_FETCHED = 'CONFIGURATION_ERROR_NOT_FETCHED';
